import { __awaiter } from "tslib";
import { ref } from 'vue';
import ApiManager from '@/managers/apimanagers';
/**
 * @summary APIアクセストークン
 */
export const useApiAccessToken = () => {
    const isLoading = ref(false);
    /**
     * @returns API申請データの取得
     */
    const getApiAccessTokens = () => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.get(`/tokens`);
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    const postApiAccessToken = (label, roles) => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.post(`/token`, { label, roles });
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    const updateApiAccessToken = (id, label, roles) => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.put(`/token/${id}/update`, { label, roles });
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    const extendApiAccessToken = (id) => __awaiter(void 0, void 0, void 0, function* () {
        let res;
        try {
            isLoading.value = true;
            res = yield ApiManager.patch(`/token/${id}/extend`, {});
        }
        finally {
            isLoading.value = false;
        }
        return res;
    });
    const deleteApiAccessToken = (id) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            yield ApiManager.delete(`/token/${id}/delete`);
        }
        finally {
            isLoading.value = false;
        }
    });
    const deleteAllApiAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoading.value = true;
            yield ApiManager.delete(`/tokens/delete-all`);
        }
        finally {
            isLoading.value = false;
        }
    });
    return {
        isLoading,
        getApiAccessTokens,
        postApiAccessToken,
        updateApiAccessToken,
        extendApiAccessToken,
        deleteApiAccessToken,
        deleteAllApiAccessToken,
    };
};
